import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ title, backgroundColor, className, onClick }) => {
  return (
    <button className={`btn w-100 ${className}`} style={{ backgroundColor }} onClick={onClick}>
      {title}
    </button>
  );
};

Button.propTypes = {
  title: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired
};

export default Button;
